export default "<div *ngIf=\"showComponent\">\n    <span [innerHTML]=\"welcomeMessage\"></span>\n</div>";